import React from 'react'

const FocusPoint = (props) => {

    return (
        <>
            <div className="focus-point">
                <h1>{props.title}</h1>
                <h2>{props.subtitle}</h2>
            </div>
        </>
    )
}

export default FocusPoint
